import { cn } from '@costar-ui/cosmos'
import React from 'react'

import HeaderRow from './primitives/header-row'
import TableHeaderCell from './table-header-cell'
import type { TableHeaderRowProps } from './types'

// This assume that the row height of the header is a constant of 2.5rem.
const stickyClassName: Record<number, string> = {
  0: 'top-0',
  1: 'top-10',
  2: 'top-20'
}

function TableHeaderRow<TData>(props: TableHeaderRowProps<TData>) {
  const { className, headerGroup, headerCellProps = {}, ...rest } = props
  const { depth } = headerGroup
  return (
    <HeaderRow className={cn(stickyClassName[depth], className)} {...rest}>
      {headerGroup.headers.map(header => (
        <TableHeaderCell key={header.id} header={header} {...headerCellProps} />
      ))}
    </HeaderRow>
  )
}

export default TableHeaderRow
